import { logout } from "@/store/authSlice";
import { clearSelectedJobId } from "@/store/selectedJobIdSlice";
import { authApi } from "./authApi";
import { candidatesApi } from "../dashBoard/candidatesApi";
import { getJobsApi } from "../dashBoard/getJobsApi";
import { candidatesInterviewApi } from "../dashBoard/candidatesInterviewsApi";
import { createJobRoleApi } from "../dashBoard/createJobRoleApi";
import { questionsSkillsBankApi } from "../dashBoard/questionsSkillsBankApi";
import type { AppDispatch } from "@/app/store";


export const logoutAndReset = () => (dispatch:  AppDispatch) => {
  // Clear auth state
  dispatch(logout());
  dispatch(clearSelectedJobId());

  // Clear ALL RTK Query cache
  dispatch(authApi.util.resetApiState());
  dispatch(candidatesApi.util.resetApiState());
  dispatch(getJobsApi.util.resetApiState());
  dispatch(candidatesInterviewApi.util.resetApiState());
  dispatch(createJobRoleApi.util.resetApiState());
  dispatch(questionsSkillsBankApi.util.resetApiState());
};
